import { 
  Waves, Mountain, TreePine, Umbrella, Sparkles, 
  ShoppingBag, Utensils, Palette, Calendar, Moon, 
  Heart, Trophy, Baby, PawPrint, Camera 
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Travel interest options used across the platform:
 * - Travel Request form (user selects what they're looking for)
 * - Travel Designer profile (designer indicates what they offer)
 * 
 * Keep this list synchronized with:
 * - user_public_profile.travel_interests column
 * - travel_requests.interests column
 */
export interface TravelInterest {
  id: string;
  /** Etichetta di fallback, in inglese. Per la UI usare `labelKey`. */
  label: string;
  /** Chiave i18n dell'etichetta, la stessa usata dal form pubblico. */
  labelKey: string;
  icon: LucideIcon;
}

export const TRAVEL_INTERESTS: TravelInterest[] = [
  { id: "beach", label: "Beach", labelKey: 'travelRequest.interestBeach', icon: Waves },
  { id: "mountain", label: "Mountain", labelKey: 'travelRequest.interestMountain', icon: Mountain },
  { id: "wildlife", label: "Wildlife", labelKey: 'travelRequest.interestWildlife', icon: TreePine },
  { id: "relax", label: "Relax", labelKey: 'travelRequest.interestRelax', icon: Umbrella },
  { id: "spa", label: "Spa", labelKey: 'travelRequest.interestSpa', icon: Sparkles },
  { id: "shopping", label: "Shopping", labelKey: 'travelRequest.interestShopping', icon: ShoppingBag },
  { id: "food", label: "Food", labelKey: 'travelRequest.interestFood', icon: Utensils },
  { id: "culture", label: "Culture", labelKey: 'travelRequest.interestCulture', icon: Palette },
  { id: "events", label: "Events", labelKey: 'travelRequest.interestEvents', icon: Calendar },
  { id: "nightlife", label: "Nightlife", labelKey: 'travelRequest.interestNightlife', icon: Moon },
  { id: "romantic", label: "Romantic Getaways", labelKey: 'travelRequest.interestRomantic', icon: Heart },
  { id: "sports", label: "Sports", labelKey: 'travelRequest.interestSports', icon: Trophy },
  { id: "family", label: "Family", labelKey: 'travelRequest.interestFamily', icon: Baby },
  { id: "pet-friendly", label: "Pet-Friendly Places", labelKey: 'travelRequest.interestPetFriendly', icon: PawPrint },
  { id: "photography", label: "Photography Spots", labelKey: 'travelRequest.interestPhotography', icon: Camera }
];

/**
 * Get interest by ID
 */
export const getTravelInterestById = (id: string): TravelInterest | undefined => {
  return TRAVEL_INTERESTS.find(interest => interest.id === id);
};

/**
 * Get multiple interests by IDs
 */
export const getTravelInterestsByIds = (ids: string[]): TravelInterest[] => {
  return ids.map(id => getTravelInterestById(id)).filter(Boolean) as TravelInterest[];
};
